import React, { Component } from 'react';
import classnames from 'classnames';

class ModuleTab extends Component {

  tabType = "MODULE";

  thisTabClicked = (e) => {
    const { tabClicked } = this.props;
    tabClicked(this.tabType);
  }

  render() {
    
    const { thisTabClicked } = this;
    const { activeTabType } = this.props;

    const moduleTabClass = classnames({
      "col-sm" : true,
      "list-tab" : true,
      "last-tab" : this.props.isLastTab,
      "active" : activeTabType === this.tabType ? true : false
    });

    return (
      <div className={moduleTabClass}
        onClick={thisTabClicked}>
        모듈
      </div>
    );
  }
}

export default ModuleTab;